import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { type BreadcrumbListSchema } from '~/vendor/cx-web/api-clients/template-api/types';
import { type FooterV2Response } from '~/vendor/cx-web/domain-types';

import { type Repub } from '~/vendor/cx-modules/constants';

import { FooterV2 } from '../footer/FooterV2';
import { type CmpProps } from '../footer/types';
import Logo from '../Logo';

import { getSocialLinks, getSocialLinksUkStyle } from './social-links';

export type CxFooterProps = {
  breadcrumbsDataSchema?: BreadcrumbListSchema;
  cmpProps?: CmpProps;
  footerData?: FooterV2Response;
  isAdmiralCookieBannerEnabled: boolean;
  isUkFooterStyle?: boolean;
  logo?: ReactNode;
  path?: string;
  repub?: Repub;
  resourcesUrl: string;
};

export const CxFooter = ({
  breadcrumbsDataSchema,
  cmpProps,
  footerData,
  isAdmiralCookieBannerEnabled,
  isUkFooterStyle,
  logo,
  path,
  repub,
  resourcesUrl,
}: CxFooterProps) => {
  const { t } = useTranslation(['label']);

  return (
    <FooterV2
      breadcrumbsDataSchema={breadcrumbsDataSchema}
      cmpProps={cmpProps}
      footerData={footerData}
      isAdmiralCookieBannerEnabled={isAdmiralCookieBannerEnabled}
      isUkFooterStyle={isUkFooterStyle}
      legalAge={t('CX_LEGAL_AGE')}
      legalText={t('CX_FOOTER_LEGAL')}
      logo={logo ?? <Logo resourcesUrl={resourcesUrl} />}
      path={path}
      repub={repub}
      socialLinks={isUkFooterStyle ? getSocialLinksUkStyle(t) : getSocialLinks(t)}
    />
  );
};
